import createCachedSelector from 're-reselect';
import { FeatureFlags } from '../../../feature-flags/feature-flags';
import Global from '../../../store/global-selectors';
import { getNormalizedCurrency } from '../helpers/alternative-rate-helpers';
import type { RateShopperRecommendation } from '../types/recommendation-types';
import type { AlternativeRates } from '../types/alternative-rate-types';

export const alternativeRatesRateShopperRecommendationSelector = createCachedSelector(
  (state: object): boolean => new FeatureFlags({ state }).enableAlternativeRatesRateShopperRecommendations,
  (state: object, fulfillmentPlanId: string): string | undefined =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'shippingConfigurationHash',
    }),
  (state: object, fulfillmentPlanId: string): AlternativeRates =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'alternativeRates',
    }),
  (isRateShopperRecommendationsEnabled, fpShippingConfigurationHash, alternativeRates): RateShopperRecommendation | undefined => {
    const isRateShopperRecommendationsDisabled = !isRateShopperRecommendationsEnabled;
    const isRecommendationStale = fpShippingConfigurationHash !== alternativeRates?.shippingConfigurationHash;
    const rateShopperRecommendation = alternativeRates?.rateShopper;
    const doesNotHaveRateShopperRecommendation = !rateShopperRecommendation?.serviceCollectionGuid;

    if (isRateShopperRecommendationsDisabled || isRecommendationStale || doesNotHaveRateShopperRecommendation) {
      return;
    }

    const { serviceCollectionGuid, serviceId, totalCost } = rateShopperRecommendation;
    const recommendedService = alternativeRates?.service?.find((service) => service.shippingServiceId === serviceId);

    return {
      serviceCollectionGuid,
      serviceId: serviceId.toString(),
      sellerProviderId: recommendedService?.sellerProviderId?.toString() || '',
      carrierId: recommendedService?.carrierId?.toString() || '',
      insuranceProviderId: recommendedService?.insuranceProviderId?.toString() || '',
      totalCost: getNormalizedCurrency(totalCost),
    };
  },
)((_, fulfillmentPlanId: string) => fulfillmentPlanId);
